
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouterOn as ObiRouterOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-router-on.js';
 
 
 

 
 export const ObiRouterOn = createComponent({
   react: React,
   tagName: 'obi-router-on',
   elementClass: ObiRouterOnElement,
   events: {
     
   }
  });
 
 